import axios from 'axios';

const REFRESH_ENDPOINT = '/api/v4/auth/refresh';
const RESET_ENDPOINT = '/api/v4/auth/reset';
const AUTH_ENDPOINT = '/api/v4/auth';

export default class AuthenticationService {

    constructor(userSession) {
        this.userSession = userSession;
    }

    async ensureAuthenticationInRequest(request) {

        if ([REFRESH_ENDPOINT, RESET_ENDPOINT].includes(request.url.toLowerCase())) {
            return;
        }

        if (this.userSession.refreshTokenIsValid &&
            (this.userSession.accessTokenIsMissing || this.userSession.accessTokenHasExpired)) {
            await this.refresh();
        }

        if (this.userSession.accessToken) {
            request.headers.Authorization = `Bearer ${this.userSession.accessToken}`
        }

        return request;
    }

    authenticate(username, password, shouldRemember, continueUrl) {
        return axios.post(AUTH_ENDPOINT, {username: username, password: password})
            .then(response => {
                this.userSession.accessToken = response.data.accessToken;
                this.userSession.refreshToken = response.data.refreshToken;
                this.userSession.shouldRemember = shouldRemember;

                return this.pickContinueDestination(response, continueUrl);
            }, err => Promise.reject(err.response.data));
    }

    refresh() {
        const refreshToken = this.userSession.refreshToken;

        return axios.post(REFRESH_ENDPOINT, null, {
            headers: {'Authorization': `Bearer ${refreshToken}`}
        }).then(successfulResponse => {
            this.userSession.accessToken = successfulResponse.data.accessToken;
            this.userSession.refreshToken = successfulResponse.data.refreshToken;

            return successfulResponse;
        }, err => Promise.reject(err.response.data));
    }

    impersonate(userId, continueUrl) {
        return axios.post(`/api/v4/auth/${userId}`)
            .then(response => {
                this.userSession.accessToken = response.data.accessToken;
                this.userSession.refreshToken = response.data.refreshToken;

                return response;
            }, err => Promise.reject(err.response.data))
            .then(response => this.pickContinueDestination(response, continueUrl));
    }

    pickContinueDestination(response, continueUrl) {
        return continueUrl || this.userSession.homeUrl || '/';
    }
}